exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".authorized-cmp .header-navbar .navbar-wrapper .navbar-header {\n  width: 436px !important; }\n\n.authorized-cmp div.navbar-container {\n  padding-top: 10px; }\n  .authorized-cmp div.navbar-container .brand-text {\n    font-weight: 500; }\n\n.authorized-cmp .no-padding {\n  padding: 0; }\n\n.authorized-cmp .ui-datatable-loading {\n  display: none !important; }\n\n.authorized-cmp .ui-widget-overlay {\n  display: none !important; }\n\n.authorized-cmp .dropdown-user .dropdown-user-link {\n  padding: 0.2rem 0.1rem;\n  min-width: 120px; }\n  .authorized-cmp .dropdown-user .dropdown-user-link .user-info {\n    width: calc(100% - 60px);\n    float: left; }\n  .authorized-cmp .dropdown-user .dropdown-user-link .dropdown-toggle-container {\n    width: 60px;\n    float: left;\n    margin-top: 0.5rem; }\n\n.authorized-cmp .dropdown-user .user-name {\n  margin-left: 0; }\n\n.authorized-cmp .dropdown-user .login-id {\n  font-size: 9px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/app/authorized/authorized.component.scss
// module id = ../../../../../src/app/authorized/authorized.component.scss
// module chunks = main